module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/233.59951871.png";